// ==============================|| OVERRIDES - DATA GRID ||============================== //

export default function DataGrid(theme) {
  return {
    MuiDataGrid: {
      defaultProps: {
        rowHeight: 48,
        headerHeight: 52
      },
      styleOverrides: {
        root: {
          border: 'none',
          borderRadius: '12px',
          overflow: 'hidden',
          backgroundColor: '#fff',
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.08)',
          '& .MuiDataGrid-main': {
            borderRadius: '12px'
          },
          // Fix pagination alignment
          '& .MuiTablePagination-root': {
            overflow: 'visible'
          },
          '& .MuiTablePagination-toolbar': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            flexWrap: 'nowrap',
            minHeight: '48px !important',
            height: '48px'
          },
          '& .MuiTablePagination-selectLabel': {
            margin: 0
          },
          '& .MuiTablePagination-displayedRows': {
            margin: 0,
            marginLeft: theme.spacing(3)
          },
          '& .MuiTablePagination-actions': {
            marginLeft: theme.spacing(2)
          },
          '& .MuiTablePagination-actions button': {
            padding: '6px'
          }
        },
        columnHeaders: {
          background: 'linear-gradient(135deg, rgba(102, 126, 234, 0.05) 0%, rgba(118, 75, 162, 0.05) 100%)',
          borderBottom: '2px solid rgba(102, 126, 234, 0.1)',
          borderRadius: 0
        },
        columnHeader: {
          fontWeight: 600,
          fontSize: '0.875rem',
          color: theme.palette.grey[700],
          '&:focus': {
            outline: 'none'
          },
          '&:focus-within': {
            outline: 'none'
          }
        },
        row: {
          cursor: 'pointer',
          transition: 'all 0.2s ease',
          '&:hover': {
            backgroundColor: 'rgba(102, 126, 234, 0.04)',
            transform: 'scale(1.001)'
          },
          '&.Mui-selected': {
            backgroundColor: 'rgba(102, 126, 234, 0.08)',
            '&:hover': {
              backgroundColor: 'rgba(102, 126, 234, 0.12)'
            }
          }
        },
        cell: {
          borderBottom: '1px solid',
          borderColor: theme.palette.grey[100],
          '&:focus': {
            outline: 'none'
          },
          '&:focus-within': {
            outline: 'none'
          }
        },
        footerContainer: {
          borderTop: '1px solid',
          borderColor: theme.palette.grey[200],
          backgroundColor: 'rgba(102, 126, 234, 0.02)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: theme.spacing(0.5, 2),
          minHeight: '48px !important',
          height: '48px'
        },
      }
    }
  };
}
